import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import PublicHeader from "@/components/PublicHeader";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const { user, refresh } = useAuth();
  const [state, setState] = useState({ status: "checking", msg: "Confirming your email…" });
  const done = useRef(false);
  useEffect(() => {
    if (done.current) {
      return;
    }
    done.current = true;
    const token = params.get("token") || "";
    if (token.length < 10) {
      setState({ status: "error", msg: "This verification link is missing or incomplete. Open the link from your email again, or request a new one from your account." });
      return;
    }
    api.post("/auth/verify-email", { token })
      .then(() => { setState({ status: "ok", msg: "Your email is confirmed. Thanks!" }); refresh(); })
      .catch((e) => setState({ status: "error", msg: errMsg(e) }));
  }, [params, refresh]);
  return (
    <div className="min-h-screen"><PublicHeader />
      <main className="mx-auto max-w-lg px-4 py-24 text-center">
        <h1 className="text-3xl font-extrabold" data-testid="verify-email-title">Email verification</h1>
        <p className={`mt-4 ${state.status === "error" ? "text-red-600" : "text-slate-600"}`} data-testid="verify-email-message">{state.msg}</p>
        <Button asChild className="mt-8 rounded-full" data-testid="verify-email-continue"><Link to={user ? "/app" : "/login"}>Continue</Link></Button>
      </main>
    </div>
  );
}
